import { render } from "./DeveloperPortal.vue?vue&type=template&id=53c84a58"
import script from "./DeveloperPortal.vue?vue&type=script&lang=js"
export * from "./DeveloperPortal.vue?vue&type=script&lang=js"

import "./DeveloperPortal.vue?vue&type=style&index=0&id=53c84a58&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__